import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'affiliations'
const verb = 'get'

export default class OspreyAffiliationsSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'trb92b92-82b3-40ea-a150-25e514edfa45'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'id,name,silos'
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/affiliations/affiliations-search.js